import type { FC } from 'react';

import { useGetAllPostsWithOwnActivities } from '@/features/api/hooks/grapevine-post/useGetAllPostsWithOwnActivities';
import { SimplePostList } from '@/features/posts/components/SimplePostList';
import { SIZE } from '@/features/posts/constants/params';

export const PostsWithActivityScreen: FC = () => {
  const {
    data: posts,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
    isRefetching
  } = useGetAllPostsWithOwnActivities({
    count: SIZE
  });

  return (
    <SimplePostList
      posts={posts}
      isLoading={isLoading}
      isError={isError}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      refetch={refetch}
      isRefetching={isRefetching}
    />
  );
};
